import { isValidEmail, isValidPhone } from '@/utils'
import { WarehouseAddress } from './onboarding'

export type AddressField = keyof WarehouseAddress

export type AddressProblem = 'required' | 'invalid' | 'too_long'

// The limits settings-api enforces when it saves the onboarding warehouse (settings.MaxCharactersIn*).
export const ADDRESS_MAX_LENGTH: Partial<Record<AddressField, number>> = {
  name: 35,
  company: 35,
  city: 30,
  addressLine1: 40,
  addressLine2: 35
}

const REQUIRED: AddressField[] = [
  'name',
  'company',
  'country',
  'city',
  'postcode',
  'addressLine1'
]

// Go's len() counts bytes, so an accented letter takes two.
const byteLength = (value: string) => new TextEncoder().encode(value).length

export function addressProblems(
  address: WarehouseAddress
): Partial<Record<AddressField, AddressProblem>> {
  const problems: Partial<Record<AddressField, AddressProblem>> = {}
  if (!isValidEmail(address.email)) problems.email = 'invalid'
  if (!isValidPhone(address.phone)) problems.phone = 'invalid'
  for (const field of REQUIRED) {
    if (!address[field]) problems[field] = 'required'
  }
  for (const [field, max] of Object.entries(ADDRESS_MAX_LENGTH)) {
    const key = field as AddressField
    if (byteLength(address[key]) > max) problems[key] = 'too_long'
  }
  return problems
}
